module.exports = __webpack_public_path__ + "static/media/buena-hover.8bd5f41a.svg";